const cartNotification = document.querySelector("cart-notification");

// Remove cart notification to the page, as it renders H2 tag of "Item Added to Your Cart" before H1.
cartNotification.remove();